// Z-index ladder — single source of truth.
//
// When adding a new layered element, add a named constant here and import it
// rather than inlining a `z-*` Tailwind utility. The ladder reads bottom to
// top: each entry must be at or above the entry above it.
//
// Tailwind's arbitrary-value syntax (`z-[60]`) is required for any value
// outside the JIT default set (10/20/30/40/50). Keep the constants as full
// Tailwind class strings — they are template-interpolated, not transformed.

export const Z = {
  EDITOR_TOOLBAR: 'z-10',
  EDITOR_DROP_OVERLAY: 'z-20',
  SHORTHAND_POPOVER: 'z-20',
  PUBLISH_BAR: 'z-30',
  SITE_SWITCHER: 'z-30',
  REFERENCE_PANEL_SCRIM: 'z-40',
  FIRST_USE_TOOLTIP: 'z-40',
  MODAL: 'z-50',
  REFERENCE_PANEL_SHEET: 'z-50',
  TOAST: 'z-[60]',
} as const;
